import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_SIGN_FORM_ADDRESS_PLACEHOLDER = defineFcm('sign_form_address_placeholder')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean', optional: true },
			},
		}),
	)
	.withDefault({ enabled: false })
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'Petition Details Page Sign Form',
		description:
			'Runtime kill switch for the sign_form_address_placeholder_experiment. When disabled the ' +
			'experiment resolves to control with fallbackReason "disabled" and the address field keeps its ' +
			"current placeholder. This is also where the experiment's US-only targeting lives: the address " +
			'field is US-only and the example string is US-shaped by construction, so enable this per-country ' +
			'rather than adding a locale check in the normalizer.',
		// `enabled: true`, not false. `withDefault({ enabled: false })` already protects production before the
		// config exists, so creating it in the admin is the deliberate act of turning the experiment on. A
		// template pre-filled `false` makes that a silent no-op — the operator reports the experiment live
		// while every session resolves `fallbackReason: 'disabled'`.
		template: { enabled: true },
		deprecated: 'FCM no longer in use — safe to delete after 2026-10-07',
	});
